<template>
  <ion-page>
    <master-layout pageTitle="مشاهده و ویرایش سفارش">
      <Loading :is="!orderLoaded" v-if="!orderLoaded"></Loading>

      <div v-if="orderLoaded">
        <div v-if="order">
          <ion-card>
            <ion-card-content>
              <h6>اطلاعات مشتری :</h6>
              <div class="d-flex-between">
                <div><i class="far fa-user"></i>&nbsp;{{ order.user.fullname }}</div>
                <div>{{ order.user.phone }}&nbsp;<i class="far fa-mobile"></i></div>
              </div>
              <hr>
              <h5>اطلاعات خودرو :</h5>
              <div class="d-flex-between">
                <div>
                  تیپ خودرو
                  <div>{{ order.carType.title }}</div>
                </div>
                <div>
                  کیلومتر فعلی
                  <div>{{ order.customer_car.current_km }}</div>
                </div>
                <div>
                  سال ساخت
                  <div>{{ order.customer_car.produce_year }}</div>
                </div>
              </div>
            </ion-card-content>
          </ion-card>
          <h6>اطلاعات سفارش</h6>
          <ion-card>
            <ion-card-content>
              <div class="d-flex-between">
                <div>شماره سفارش :
                  <div>{{ order.order_number }}</div>
                </div>
                <div>
                  تاریخ ثبت :
                  <div>{{ order.created_date }}</div>
                </div>
              </div>
            </ion-card-content>
          </ion-card>
          <div v-if="!finishFlag">
            <h5>آیتم های سفارش</h5>
            <ion-card class="center order-items" v-for="(item,index) in orderItems" :key="index">
              <ion-card-content>
                <div class="order_item_div">
                  <div>نوع :</div>
                  <div class="bold">{{ item.type_title }}</div>
                  <div v-if="!order.status">
                    <button @click="removeItem(index)" class="btn del-btn"><i class="fas fa-times text-danger"></i></button>
                  </div>
                </div>
                <div class="order_item_div">
                  <span>عنوان :</span>
                  <span>
                    {{ item.item_title }}
                    <div>{{ item.attr_str }}</div>
                  </span>
                </div>
                <div class="order_item_div">
                  <div>تعداد :</div>
                  <div><input type="tel" :disabled="order.status" @keyup="changeOrderItemQuantity($event,index)" :value="item.quantity" class="form-control"
                              name="quantity"></div>
                </div>
                <div class="order_item_div">
                  <div>مبلغ واحد :</div>
                  <div>
                  <input :disabled="order.status" class="form-control" @keyup="changeOrderItemPrice($event,index)" type="tel" :value="item.price">
                  </div>
                </div>
                <div class="order_item_div">
                  <div></div>
                  <div>
                    جمع :
                  <Money :number="item.total" ></Money> تومان
                  </div>
                </div>
              </ion-card-content>
            </ion-card>
            <ion-card v-if="!orderStatus">
              <ion-card-content>
                <div>افزودن آیتم به سفارش</div>
                <ion-button color="secondary" @click="add_product = true">افزودن محصول</ion-button>&nbsp;
                <ion-button color="success" @click="add_product = false" >افزودن خدمت</ion-button>
                <div v-if="add_product" class="product_div p-2 border mt-2">
                  <div class="form-group">
                    <label>انتخاب محصول</label>
                    <ali-ajax-select :on-change="getProductAttr" route="app/GetProductForSelect" title="محصولات"
                                     itemTitle="title" name="product_id" desc="جستجو محصول..."
                                     itemId="_id"></ali-ajax-select>
                    <ali-select :on-change="reg_attr" v-if="attr_items.length" :items="attr_items" search="true"
                                title="ویژگی" itemTitle="str" desc="ویژگی را انتخاب کنید!!!" name="attr_hash"
                                itemId="hash"></ali-select>
                  </div>
                  <ion-button color="warning" @click="AddItemToOrder('product')">افزودن</ion-button>
                </div>
                <div v-if="!add_product" class="service_div p-2 border mt-2">
                  <div class="form-group">
                    <label>خدمت</label>
                    <ali-ajax-select :on-change="changeService" route="app/GetServiceForSelect" title="خدمات"
                                     itemTitle="title" name="service_id" desc="جستجو خدمت" itemId="_id"></ali-ajax-select>
                  </div>
                  <ion-button color="warning" @click="AddItemToOrder('service')" >
                    افزودن
                  </ion-button>
                </div>
              </ion-card-content>
            </ion-card>
            <ion-card>
              <ion-card-content>
                <div>
                جمع کل  :
                  <Money :number="order_total"></Money> تومان
                </div>
                <div class="order_item_div">
                <div>
                  <label>تخفیف محصولات</label>
                  <input type="tel" :disabled="order.status" class="form-control p-discount-input" v-model="product_discount" name="product_discount">
                </div>
                <div>
                  <label>تخفیف خدمات</label>
                  <input type="tel" :disabled="order.status" class="form-control s-discount-input" v-model="service_discount" name="service_discount">
                </div>
                </div>
                <div>تخفیف کلی :
                <money :number="total_discount"></money>
                </div>
                    <div class="form-group">
                      <label>توضیحات تخفیف</label>
                      <textarea :disabled="order.status" name="discount_description"
                                v-model="order.admin_discount_description"
                                class="form-control admin_discount_description"></textarea>
                    </div>
                <div class="negative_margin">
                  <ion-button color="success" v-if="!orderStatus" @click="changeOrderItem()" >ویرایش اطلاعات سفارش
                  </ion-button>
                  <ion-button color="secondary" v-if="!orderStatus" @click="changeFinishFlag()">اتمام سفارش</ion-button>
                </div>
              </ion-card-content>
            </ion-card>
          </div>
          <ion-card v-if="!orderStatus && finishFlag">
            <ion-card-content>
              <div class="h6">
                جمع کل  :
                <Money :number="order_total"></Money> تومان
              </div>
              <div class="order_item_div">
                <div>
                  <label>نوع پرداخت</label>
                  <select v-model="pay_type" autocomplete="off" class="form-control" name="pay_type">
                    <option disabled>نوع پرداخت را انتخاب کنید.</option>
                    <option  v-for="(item,index) in pay_types" :key="index" :value="{val : item.val}">{{item.title}}</option>
                  </select>
                </div>
                <div>
                  <label>مانده</label>
<!--                  <ion-input type="text" :value="order.debt"></ion-input>-->
                  <input type="tel" name="debt" v-model="order.debt" class="form-control mr-2">
                </div>
              </div>
              <div class="order_item_div">
                <div>
                  <label>حجم روغن سوخته(لیتر)</label>
                  <input v-model="used_oil" type="tel" name="order_oil" class="form-control">
                </div>
                <div>
                  <label>کیلومتر فعلی خودرو</label>
                  <input type="tel" v-model="current_km" name="currentKm" class="form-control mr-2">
                </div>
              </div>
              <div class="order_item_div">
                <div>
                  <label>تعداد تقریبی روز برای مراجعه بعدی</label>
                  <input v-model="daysForNextVisit" type="tel" name="days_for_next_visit" class="form-control">
                </div>
              </div>
                <div v-if="use_products.length" class="mt-2">
                  لطفا محصولاتی که در سرویس استفاده شده را انتخاب کنید.
                </div>
                <div v-for="(item,index) in use_products" :key="index">
                  <div class="custom-control custom-checkbox mb-3 mt-2">
                    <input value="1" autocomplete="off"
                           @change="changeNextServiceCheckbox(index)"
                           type="checkbox"
                           :checked="item.used_in_service"
                           class="custom-control-input"
                           :id="'customCheck_'+index" name="in_local">
                    <label class="custom-control-label" :for="'customCheck_'+index">&nbsp;{{ item.title }}</label>
                  </div>
                  <div class="d-flex-between" v-if="item.used_in_service">
                    <div>
                      <label>سرویس بعدی به روز</label>
                      <input v-model="item.service_time" type="tel" name="next_service_time" class="form-control">
                    </div>
                    <div>
                      <label>سرویس بعدی به کیلومتر</label>
                      <input v-model="item.service_distance" type="tel" name="next_service_distance" class="mr-2 form-control">
                    </div>
                  </div>
                </div>
                <ion-button @click="finishOrder()" color="secondary">تایید اتمام سفارش</ion-button>
                <ion-button @click="changeFinishFlag()" color="danger">اصلاح سفارش</ion-button>
            </ion-card-content>
          </ion-card>
          <ion-card v-if="orderStatus">
            <ion-card-content>
              <div class="h6">
                <div class="order_item_div">
                  <div>
                    نوع پرداخت :
                    <span v-if="order.pay_type === 'cheque'">چک</span>
                    <span v-else-if="order.pay_type === 'pos'">کارتخوان</span>
                    <span v-else>نقدی</span>
                  </div>
                  <div>
                    میزان روغن سوخته :
                    {{order.used_oil}}
                    لیتر
                  </div>
                </div>
              </div>
              <div v-if="order.debt" class="order_item_div">
                <div>
                <div>مانده سفارش :</div>
                <input v-model="order.debt" type="tel" class="form-control">
                </div>
                <div>
                  <ion-button @click="changeDebt()" color="success">ثبت</ion-button>
                </div>
              </div>
              <div class="order_item_div">
                <AjaxForm route="shop/order/sendCustomerInvoice/">
                  <input type="hidden" :value="order._id" name="order_id">
                  <ion-button type="submit" color="success">ارسال فاکتور</ion-button>
                </AjaxForm>
                <ion-button color="warning" @click="openShareIntent">اشتراک فاکتور</ion-button>
              </div>
            </ion-card-content>
          </ion-card>

        </div>
        <div  v-if="error" class="alert alert-danger">
          {{ error }}
        </div>
      </div>

    </master-layout>
  </ion-page>
</template>

<script>
import {
  alertController,IonCardContent,
  IonPage
} from '@ionic/vue';
import {showSystemNoti} from "@/shared/helper";
import {mapActions} from "vuex";
import AliAjaxSelect from "@/components/aliAjaxSelect";
import AliSelect from "@/components/aliSelect";
import Money from "@/components/Money";
import AjaxForm from "@/components/AjaxForm";
import Loading from "../../components/Loading";

// import {getFormData} from '@/shared/helper'

export default {
  components: {
    AjaxForm,
    AliAjaxSelect,
    AliSelect,
    IonPage,IonCardContent,Loading,
    Money
  },
  data()
  {
    return {
      daysForNextVisit : 0,
      add_product: true,
      add_service: false,
      order: null,
      orderLoaded: false,
      orderItems: [],
      attr_items: [],
      product_discount: 0,
      service_discount: 0,
      total_discount: 0,
      customer_id: null,
      customer: null,
      product_id: null,
      attr: null,
      service_id: null,
      product_type: null,
      cars: [],
      car_id: null,
      discount_note: '',
      order_total: 0,
      orderStatus: 0,
      finishFlag: false,
      use_products: [],
      debt : 0,
      used_oil : 0,
      current_km : 0,
      pay_type : '',
      pay_types : [
        {title: 'نقدی', val: 'cash'},
        {title: 'چک', val: 'cheque'},
        {title: 'کارتخوان', val: 'pos'},
      ]
    }
  },
  async mounted()
  {
  },
  async created()
  {
    await this.init();
  },
  methods: {
    async init()
    {
      this.id = this.$route.params.id;
      this.orderLoaded = false;
      this.order = null;
      this.product_discount = 0;
      this.service_discount = 0;
      this.orderItems = [];
      this.total_discount = 0;
      this.car_id = null;
      this.customer_id = null;
      this.orderStatus = 0;
      this.use_products = [];
      this.finishFlag = false;
      this.daysForNextVisit = 0;
      const result = await this.getOrder(this.id);
      if (result)
      {
        if (result.ok)
        {
          this.orderLoaded = true;
          this.order = result.order;
          const order = this.order;
          const items = await this.getOrderItems(this.order._id);
          if (items.ok)
          {
            this.product_discount = this.order.admin_product_discount_amount;
            this.service_discount = this.order.admin_service_discount_amount;
            this.orderItems = items.items;
            this.total_discount = this.service_discount + this.product_discount;
            this.car_id = this.order.car_id;
            this.customer_id = this.order.user_id;
            this.orderStatus = this.order.status;
            if (order.status === 0)
            {
              await this.calculateOrderSum();
              const products = await this.getProductToSetLastService(order._id);
              if (products.ok)
              {
                this.use_products = products.products;
              }
            }
          }
        }
        else
        {
          this.orderLoaded = true;
          this.error = result.error
        }
      }
      else
      {
        this.orderLoaded = true;
        this.error = 'خطا در برقراری ارتباط با سرور'
      }
    },
    openShareIntent()
    {

    },
    //
    ...mapActions("order", {
      getOrder: 'getOrder',
      getOrderItems: 'getOrderItems',
      addProductToOrder: 'addProductToOrder',
      editOrderItems: 'editOrderItems',
      addServiceToOrder: 'addServiceToOrder',
      finishOrderFunc : 'finishOrder',
      changeOrderDebt : 'changeOrderDebt',
      getProductToSetLastService: 'getProductToSetLastService'
    }),
    ...mapActions("app", {
      getProductVariableAttr: 'getProductVariableAttr'
    }),
    AddItemToOrder: async function (item)
    {
      if (item === 'product')
      {
        const customer_id = this.customer_id;
        const product_id = this.product_id;
        const product_type = this.product_type;
        const car_id = this.car_id;
        let attr = this.attr;
        if (!product_id)
          return showSystemNoti('danger', 'محصول را انتخاب کنید.');
        if (product_type === 'variable' && !attr)
          return showSystemNoti('danger', 'ویژگی محصول را انتخاب کنید.')
        const check = await this.addProductToOrder({
          id: product_id,
          attr_hash: attr,
          car_id: car_id,
          customer_id: customer_id
        })
        if (check.ok)
        {
          check.type = 'product';
          check.type_title = 'محصول';
          check.total = 0;
          check.quantity = 1;
          this.orderItems.push(check)
        }
        else
          return showSystemNoti('danger', check.msg)
      }
      else if (item === 'service')
      {
        const service_id = this.service_id;
        if (!service_id)
          return showSystemNoti('danger', 'خدمت را انتخاب کنید.');
        const check = await this.addServiceToOrder(service_id);
        if (check.ok)
        {
          check.quantity = 1;
          check.total = 0;
          this.orderItems.push(check);
        }
        else
          return showSystemNoti('danger', check.error);

      }
      // this.orderItems.push({
      //   type:'mahsool',
      //   title: 'test'
      // })
    },
    getProductAttr: async function (c)
    {
      if (c && c.length)
      {
        c = c[0];
        this.product_id = c._id;
        this.product_type = c.product_type;
        if (c.product_type === 'simple')
        {
          this.attr_items = [];
          this.attr = null;
        }
        else
        {
          const attrs = await this.getProductVariableAttr(c._id);
          if (attrs && attrs.length)
          {
            this.attr_items = attrs;
          }
          else
          {
            this.attr_items = [];
            this.attr = null;
          }
        }
      }
      else
      {
        this.attr_items = [];
        this.product_id = null;
      }
    },
    reg_attr: async function (a)
    {
      if (a && a.length)
      {
        this.attr = a[0].hash;
      }
      else
        this.attr = null;
    },
    changeService: async function (c)
    {
      if (c && c.length)
      {
        this.service_id = c[0]._id;
      }
      else
        this.service_id = null;
    },
    removeItem: function (index)
    {
      this.orderItems.splice(index, 1);
    },
    changeOrderItemQuantity: function (event, index)
    {
      this.orderItems[index].quantity = (event.target.value)
      this.calculateOrderSum();
    },
    changeOrderItemPrice: function (event, index)
    {
      this.orderItems[index].price = (event.target.value)
      this.calculateOrderSum();
    },
    changeOrderItem: async function ()
    {
      const order_items = this.orderItems;
      // const car_id = this.car_id;
      // const customer_id = this.customer_id;
      const product_discount = this.product_discount;
      const service_discount = this.service_discount;
      const discount_note = this.discount_note;
      // if (!customer_id)
      //   return showSystemNoti('danger','مشتری را انتخاب کنید.');
      // if (!car_id)
      //   return showSystemNoti('danger','خودروی مشتری را انتخاب کنید.');
      if (!order_items.length)
        return showSystemNoti('danger', 'حداقل برای سفارش باید یک آیتم اضافه کنید.');

      let out = {
        items: order_items,
        // car_id : car_id,
        order_id: this.order._id,
        product_discount_amount: product_discount,
        service_discount_amount: service_discount,
        // customer_id : customer_id,
        admin_discount_description: discount_note
      };
      const check = await this.editOrderItems(out);
      if (check.ok)
      {
        return showSystemNoti('success', check.message)
      }
      else
        return showSystemNoti('danger', check.error);

    },
    calculateOrderSum: async function ()
    {
      const orderItems = this.orderItems;

      let total = 0;
      for (let i = 0; i < orderItems.length; i++)
      {
        let quantity = orderItems[i].quantity;
        let price = orderItems[i].price;
        if (isNaN(quantity) || isNaN(price))
        {
          orderItems[i].total = 0;
        }
        else
        {
          orderItems[i].total = parseInt(quantity) * parseInt(price);
          total += orderItems[i].total;
        }
        this.orderItems[i] = orderItems[i];
      }
      this.order_total = total - this.total_discount;

    },
    changeFinishFlag: async function ()
    {
      this.finishFlag = !this.finishFlag;
      // window.scrollBy(0, 200);
    },
    finishOrder: async function ()
    {
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'آیا اطمینان دارید!',
            message: 'سفارش به حالت تمام شده تغییر وضعیت داشته باشد',
            buttons: [
              {
                text: 'لفو',
                role: 'cancel',
                cssClass: 'danger',
                handler: blah =>
                {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'تایید',
                handler: async () =>
                {
                  await this.finishOrderConfirm();
                },
              },
            ],
          });
      return alert.present();
    },
    async finishOrderConfirm()
    {
      const self = this;
      const current_km = this.current_km;
      const used_oil = this.used_oil;
      const use_products = this.use_products;
      const out = {
        current_km: current_km,
        used_oil: used_oil,
        use_products: use_products,
        order_id : this.order._id,
        debt : this.order.debt,
        days_for_next_visit : this.daysForNextVisit,
        pay_type : this.pay_type.val
      };
      let check = await this.finishOrderFunc(out);
      if (check.ok)
      {
        // this.order.status = 1;
        return showSystemNoti('success',check.message,async function ()
        {
          await self.init();
        });
      }
      else
        return showSystemNoti('danger',check.error);
    },
    changeNextServiceCheckbox: async function (index)
    {
      if (this.use_products[index].used_in_service)
        this.use_products[index].used_in_service = false;
      else
        this.use_products[index].used_in_service = true;
    },
    async changeDebt()
    {
      const self = this;
      const check = await this.changeOrderDebt({order_id : this.order._id,debt : this.order.debt});
      if (check.ok)
      {
        if (this.order.debt === '0')
          this.order.debt = 0;
        const debt = this.order.debt;
        return showSystemNoti('success',check.message,function ()
        {
          if (!debt)
            self.$router.push({path: '/'})
        });
      }
      else
        return showSystemNoti('danger',check.error);
    }
  },
  watch: {
    cars: function ()
    {
      // $('.custom-control-input').prop('checked',false);
    },
    add_product: function ()
    {
      this.product_id = null;
      this.service_id = null;
      this.attr = null;
    },
    product_discount: function ()
    {
      this.total_discount = parseInt(this.product_discount) + parseInt(this.service_discount);
      this.calculateOrderSum();
    },
    service_discount: function ()
    {
      this.total_discount = parseInt(this.product_discount) + parseInt(this.service_discount);
      this.calculateOrderSum();
    },
    "$route.path": {
      handler(newUrl,oldUrl)
      {
        if (newUrl.toLowerCase().indexOf('order/edit/') >= 0 && oldUrl.toLowerCase().indexOf('order/edit/') < 0)
        {
          this.init()
        }
      },
      deep:true
    },
  }
}
</script>

<style scoped>
.d-flex-between {
  display: flex;
  justify-content: space-between;
  text-align: center;
}
.order_item_div
{
  display: flex;
  justify-content: space-between;
  text-align: center;
  margin-bottom: 9px;
  align-self: center;
}
.order_item_div > div
{
  align-self: center;
}
.bold
{
  font-weight: 900;
  color: black;
}
.del-btn
{
  background: transparent;
}
.admin_discount_description
{
  height: 100px;
}
.order-items
{
  background: #CFD8DC;
  color: #222222;
}
.h6{
  font-size: 15px;
  font-weight: 900;
  color: black;
}
.s-discount-input
{
  margin-right: 4px;
}
.negative_margin {
  margin: 0 -15px;
  text-align: center;
}
.mr-2
{
  margin-right: 5px;
}
</style>